<ng-container *ngIf="error$ | async as errorMsg; else resultTpl">
  <nz-result nzStatus="error" nzTitle="An error ocurred" [nzSubTitle]="errorMsg"></nz-result>
</ng-container>

<ng-template #resultTpl>
  <ng-container *ngIf="loading$ | async; else mouldLogsTpl">
    <nz-skeleton></nz-skeleton>
  </ng-container>
</ng-template>

<ng-template #mouldLogsTpl>
  <nz-table
    #basicTable
    [nzData]="(mouldLogs$ | async) ?? []"
    nzBordered
    nzShowPagination="false"
    nzFrontPagination="false"
  >
    <thead>
      <tr>
        <th>Created at</th>
        <th>Created by</th>
        <th>Log code</th>
        <th>Short text</th>
        <th>Item text</th>
        <th>Long text</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let mouldLog of basicTable.data; trackBy: trackByRef">
        <td>{{ mouldLog.logDate | date: 'shortDate' }}</td>
        <td>{{ mouldLog.user }}</td>
        <td>{{ mouldLog.codeNumber }}</td>
        <td>{{ mouldLog.shortText }}</td>
        <td>{{ mouldLog.statusText }}</td>
        <td>
          <pre style="white-space: pre-wrap">{{ mouldLog.longText }}</pre>
        </td>
      </tr>
    </tbody>
  </nz-table>
</ng-template>
